import CalendarLocale from '@rc-component/picker/locale/da_DK';
import TimePickerLocale from '../../time-picker/locale/da_DK';
// Merge into a locale object
const locale = {
    lang: {
        placeholder: 'Vælg dato',
        yearPlaceholder: 'Vælg år',
        quarterPlaceholder: 'Vælg kvartal',
        monthPlaceholder: 'Vælg måned',
        weekPlaceholder: 'Vælg uge',
        rangePlaceholder: ['Startdato', 'Slutdato'],
        rangeYearPlaceholder: ['Startår', 'Slutår'],
        rangeQuarterPlaceholder: ['Startkvartal', 'Slutkvartal'],
        rangeMonthPlaceholder: ['Startmåned', 'Slutmåned'],
        rangeWeekPlaceholder: ['Startuge', 'Slutuge'],
        ...CalendarLocale,
    },
    timePickerLocale: {
        ...TimePickerLocale,
    },
};
// All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
export default locale;
